import {toFixed} from '../global.js';

$(function () {
    setInterval(cofs_update, 5000)
})
let tournament_id = $('#js_tournament_id').val();
// cofs autoupdater
export const cofs_update = () => {
    if (!tournament_id) {
        tournament_id = $('#js_tournament_id').val();
    }
    let request = $.get('https://' + window.location.host + `/widget/cofs_api.php?tournament_id=${tournament_id}`, function (data) {
        // console.log(data); 
        if (data.response.cofs) {
            data.response.cofs.forEach(cof => {
                let bet_type = cof.type;
                let isLive = bet_type.indexOf("live") !== -1;
                let fixedPrecision = isLive ? 3 : 2;

                let $bet_item_div_team1 = $(`div.bet-item[data-type="${bet_type}"][data-team="team_1"]`);
                let $bet_item_div_team2 = $(`div.bet-item[data-type="${bet_type}"][data-team="team_2"]`);

                let team1_oldcof = Number($(`span.js_${bet_type}_team_1_cof`).data('cof'));
                let team1_cof = toFixed(cof.team_1_cof, fixedPrecision);
                $(`span.js_${bet_type}_team_1_cof`).data('cof', team1_cof).text(`${toFixed(+team1_cof + 1, fixedPrecision)}`);
                $(`span.js_${bet_type}_team_1_rate`).text(`${cof.team_1_rate}`);
                $(`input.js_${bet_type}_team_1_rate`).val(`${cof.team_1_rate}`);
                $(`input.js_${bet_type}_team_1_cof`).val(team1_cof);

                let team2_oldcof = Number($(`span.js_${bet_type}_team_2_cof`).data('cof'));
                let team2_cof = toFixed(cof.team_2_cof, fixedPrecision);
                $(`span.js_${bet_type}_team_2_cof`).data('cof', team2_cof).text(`${toFixed(+team2_cof + 1, fixedPrecision)}`);
                $(`span.js_${bet_type}_team_2_rate`).text(`${cof.team_2_rate}`);
                $(`input.js_${bet_type}_team_2_rate`).val(`${cof.team_2_rate}`);
                $(`input.js_${bet_type}_team_2_cof`).val(team2_cof);

                let show_lock_icon1 = false
                let show_lock_icon2 = false;
                //для лайвов
                if (isLive) {
                    let lowest_allowed_cof = 0.02;
                    let $live_team_1_span = $(`span.js_${bet_type}_team_1_cof`);
                    let $live_bet_team1_div = $live_team_1_span.parents(`div.bet-item`);
                    if ($live_bet_team1_div.data(`time_close_live`) < cof.time_from_update
                        || +team1_cof < lowest_allowed_cof) {
                        //$live_bet_team1_div.addClass(`disabled`);
                        show_lock_icon1 = true;
                    } else {
                        //$live_bet_team1_div.removeClass(`disabled`);
                        show_lock_icon1 = false;
                    }
    
                    let $live_team_2_span = $(`span.js_${bet_type}_team_2_cof`);
                    let $live_bet_team2_div = $live_team_2_span.parents(`div.bet-item`);
                    if ($live_bet_team2_div.data(`time_close_live`) < cof.time_from_update
                        || +team2_cof < lowest_allowed_cof) {
                        //$live_bet_team2_div.addClass(`disabled`);
                        show_lock_icon2 = true;
                    } else {
                        //$live_bet_team2_div.removeClass(`disabled`);
                        show_lock_icon2 = false;
                    }


                    //grey out teams-bet__title
                    if ($live_bet_team1_div.hasClass(`disabled`) && $live_bet_team2_div.hasClass(`disabled`)) {
                        
                    } else {
                        
                    }
                }



                //arrows
                let show_up_arrow1 = false;
                let show_down_arrow1 = false;
                if (team1_cof > team1_oldcof) {
                    show_up_arrow1 = true;
                } else if (team1_cof < team1_oldcof) {
                    show_down_arrow1 = true;
                }
                
                let show_up_arrow2 = false;
                let show_down_arrow2 = false;
                if (team2_cof > team2_oldcof) {
                    show_up_arrow2 = true;
                } else if (team2_cof < team2_oldcof) {
                    show_down_arrow2 = true;
                }
                
                

                //consider what icon to show team1
                let $lock_team1 = $bet_item_div_team1.find('.js_lock_icon');
                let $up_arrow_team1 = $bet_item_div_team1.find('.js_arrows_up_icon');
                let $down_arrow_team1 = $bet_item_div_team1.find('.js_arrows_down_icon');
                let $dash_team1 = $bet_item_div_team1.find('.js_dash_icon');
                if (show_lock_icon1) {
                    $lock_team1.show();
                    $up_arrow_team1.hide();
                    $down_arrow_team1.hide();
                    $dash_team1.hide();
                } else if (show_up_arrow1) {
                    $lock_team1.hide();
                    $up_arrow_team1.show();
                    $down_arrow_team1.hide();
                    $dash_team1.hide();
                } else if (show_down_arrow1) {
                    $lock_team1.hide();
                    $up_arrow_team1.hide();
                    $down_arrow_team1.show();
                    $dash_team1.hide();
                } else {
                    $lock_team1.hide();
                    $up_arrow_team1.hide();
                    $down_arrow_team1.hide();
                    if ($bet_item_div_team1.find(`span .icon:not([style*="display: none"])`).length == 0) {
                        $dash_team1.show();
                    }
                }
                let $lock_team2 = $bet_item_div_team2.find('.js_lock_icon');
                let $up_arrow_team2 = $bet_item_div_team2.find('.js_arrows_up_icon');
                let $down_arrow_team2 = $bet_item_div_team2.find('.js_arrows_down_icon');
                let $dash_team2 = $bet_item_div_team2.find('.js_dash_icon');
                if (show_lock_icon2) {
                    $lock_team2.show();
                    $up_arrow_team2.hide();
                    $down_arrow_team2.hide();
                    $dash_team2.hide();
                } else if (show_up_arrow2) {
                    $lock_team2.hide();
                    $up_arrow_team2.show();
                    $down_arrow_team2.hide();
                    $dash_team2.hide();
                } else if (show_down_arrow2) {
                    $lock_team2.hide();
                    $up_arrow_team2.hide();
                    $down_arrow_team2.show();
                    $dash_team2.hide();
                } else {
                    $lock_team2.hide();
                    $up_arrow_team2.hide();
                    $down_arrow_team2.hide();
                    if ($bet_item_div_team2.find(`span .icon:not([style*="display: none"])`).length == 0) {
                        $dash_team2.show();
                    }
                }


            });

            $('.input-range').change();
        }
    })
        // .done(function () {
        //     console.log("second success");
        // })
        .fail(function (jqXHR, textStatus, error) {
            console.error(error);
        })
    // .always(function () {
    //     console.log("finished");
    // });
}